/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TCWorkflowCreateTriggerBodyParams } from '../models/TCWorkflowCreateTriggerBodyParams';
import type { TCWorkflowTriggerListResponse } from '../models/TCWorkflowTriggerListResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AutomationsWorkflowsTriggersService {
    /**
     * Attach a trigger to a workflow
     * @param workflowId
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static createWorkflowTrigger(
        workflowId: string,
        requestBody: TCWorkflowCreateTriggerBodyParams,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/automations/workflows/{workflowId}/triggers',
            path: {
                'workflowId': workflowId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * List triggers for a workflow version
     * @param workflowId
     * @param version
     * @returns TCWorkflowTriggerListResponse Ok
     * @throws ApiError
     */
    public static listWorkflowTriggers(
        workflowId: string,
        version: string,
    ): CancelablePromise<TCWorkflowTriggerListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/automations/workflows/{workflowId}/versions/{version}/triggers',
            path: {
                'workflowId': workflowId,
                'version': version,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * Delete a workflow trigger
     * @param workflowId
     * @param version
     * @param triggerId
     * @returns void
     * @throws ApiError
     */
    public static deleteWorkflowTrigger(
        workflowId: string,
        version: string,
        triggerId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/automations/workflows/{workflowId}/versions/{version}/triggers/{triggerId}/delete',
            path: {
                'workflowId': workflowId,
                'version': version,
                'triggerId': triggerId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
